import { render, staticRenderFns } from "./estilo-vida-editar.vue?vue&type=template&id=c786032a&scoped=true&"
import script from "./estilo-vida-editar.vue?vue&type=script&lang=js&"
export * from "./estilo-vida-editar.vue?vue&type=script&lang=js&"
import style0 from "./estilo-vida-editar.vue?vue&type=style&index=0&id=c786032a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c786032a",
  null
  
)

export default component.exports